export default __webpack_public_path__ + "73a03e33de63869cbb03c0d07cb9f1f7.png";